import { atom } from 'jotai';
import isEqual from 'lodash/isEqual';

import { ScannerDetailRecord } from '../types/sidecar';

export type ScannerFormState = {
  name: string;
};

const initialState = (): ScannerFormState => ({
  name: '',
});

const mapScannerToForm = (scanner: ScannerDetailRecord): ScannerFormState => ({
  name: scanner.name,
});

export const $scannerForm = atom<ScannerFormState>(initialState());
export const $discardScannerBaseline = atom<ScannerFormState | null>(null);
export const $lastPopulatedScannerId = atom<string | undefined>(undefined);
export const $isScannerFormPopulated = atom<boolean>(false);

export const $hasUnsavedScannerChanges = atom((get) => {
  const form = get($scannerForm);
  const baseline = get($discardScannerBaseline);

  if (!baseline) return false;

  return !isEqual(form, baseline);
});

export const $canSubmitScannerForm = atom((get) => {
  const form = get($scannerForm);
  if (!form.name.trim()) return false;
  return true;
});

export const $populateScannerFormFromScanner = atom(
  null,
  (_get, set, scanner: ScannerDetailRecord) => {
    const formState = mapScannerToForm(scanner);
    set($scannerForm, formState);
    set($discardScannerBaseline, formState);
    set($lastPopulatedScannerId, scanner.id);
    set($isScannerFormPopulated, true);
  },
);

export const $resetScannerFormToScanner = atom(null, (get, set) => {
  const baseline = get($discardScannerBaseline);
  if (baseline) {
    set($scannerForm, baseline);
  }
});

export const $populateScannerFormAction = atom(
  null,
  (get, set, scanner: ScannerDetailRecord | null | undefined) => {
    if (!scanner) return;

    const currentScannerId = scanner.id;
    const lastScannerId = get($lastPopulatedScannerId);

    if (currentScannerId !== lastScannerId) {
      set($isScannerFormPopulated, false);
    }

    if (!get($isScannerFormPopulated)) {
      set($populateScannerFormFromScanner, scanner);
    }
  },
);

export const $resetScannerForm = atom(null, (_get, set) => {
  set($scannerForm, initialState());
  set($discardScannerBaseline, null);
  set($lastPopulatedScannerId, undefined);
  set($isScannerFormPopulated, false);
});
